import NavBar from '@/components/Nav.vue';

import enums from '@/configs/enums.js';
import client from '@/configs/client.js';

export default {
    name: 'OrderPage',
    components: {
        NavBar,
    },
    data() {
        return {
            page: 1,
            more: true,
            loading: false,
            orders: [],
            state: null,
            states: enums.orderState,
            timer: null,
            checkTimer: null,
            entityKey: null,
            successType: ''
        }
    },
    created() {
        this.getOrderList();
    },
    mounted() {
        this.timer = setInterval(() => {
            this.orders.map(this.handleOrder);
        }, 1000);
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        clearInterval(this.timer);
        clearInterval(this.checkTimer);
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        payment(order) {
            // 判断在端内还是端外
            if (client.xinhua) {
                this.$http.get('order/' + order.id + '/queryOrder').then(result => {
                    let data = {
                        uuid: result.data.productNumber,
                        priceId: result.data.priceId,
                        type: 12,
                        orderId: result.data.orderNumber
                    }
                    if (client.ios) {
                        window.webkit.messageHandlers.goPayPage.postMessage(data);
                    } else {
                        /* eslint-disable */
                        xinhuanet.goPayPage(JSON.stringify(data));
                        /* eslint-enable */
                    }
                });
                // 检测订单结果
                clearInterval(this.checkTimer);
                this.checkTimer = setInterval(() => {
                    this.$http.get('order/' + order.id + '/check').then(result => {
                        if (order.state != enums.orderState.waiting) {
                            order.state = result.data.state;
                            if (order.state == enums.orderState.complete) {
                                this.entityKey = result.data.entity.id;
                                this.successType = result.data.entity.product.type == enums.productType.container ? 'unpack' : 'common';
                                if (this.successType == 'unpack') {
                                    this.openEntity = result.data.entity;
                                }
                            }
                            clearInterval(this.checkTimer);
                        }
                    })
                }, 2000);
            } else {
                this.$http.get('order/' + order.id + '/cashier', {params: {url: location.href}}).then(result => {
                    location.href = result.data.url;
                });
            }
        },
        getOrderList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('order', {params: {state: this.state, page: this.page}}).then(result => {
                    this.page++;
                    this.loading = false;
                    this.more = result.data.more;
                    result.data.orders.map(this.handleOrder)
                    this.orders = this.orders.concat(result.data.orders);
                })
            }
        },
        changeState(value) {
            this.state = value;
            this.page = 1;
            this.more = true;
            this.loading = false;
            this.orders = [];
            this.getOrderList();
        },
        handleOrder(order) {
            if (order.state == this.states.waiting) {
                let diff = this.getTimeDiff(order.expire_time);
                order.diffMinute = diff.minute < 10 ? '0' + diff.minute : diff.minute;
                order.diffSecond = diff.second < 10 ? '0' + diff.second : diff.second;
                if (diff.minute <= 0 && diff.second <= 0) {
                    order.state = this.states.cancel;
                }
            }
        },
        getTimeDiff(time) {
            let diff = (Date.parse(new Date(time)) - Date.parse(new Date)) / 1000;
            return {minute: Math.floor(diff / 60), second: diff % 60};
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getOrderList();
            }
        }
    }
}